import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'organization-logo-form',
  templateUrl: './organization-logo-form.component.html',
  styleUrls: ['./organization-logo-form.component.scss'],
})
export class OrganizationLogoFormComponent {
  @Input() public logoUri: string;
  @Input() public organizationId: number;
  @Output() public removeLogoSource$: EventEmitter<void> = new EventEmitter<void>();
  @Output() public uploadLogoControlSource$: EventEmitter<File> = new EventEmitter<File>();

  public isLoading: boolean = false;

  constructor() {}

  public uploadLogo(file: File): void {
    this.uploadLogoControlSource$.emit(file);
  }

  public removeLogo(): void {
    this.removeLogoSource$.emit();
  }
}
